import { render, staticRenderFns } from "./TextEditorFree.vue?vue&type=template&id=926979be&scoped=true"
import script from "./TextEditorFree.vue?vue&type=script&lang=js"
export * from "./TextEditorFree.vue?vue&type=script&lang=js"
import style0 from "./TextEditorFree.vue?vue&type=style&index=0&id=926979be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926979be",
  null
  
)

export default component.exports